import styled from 'styled-components';

export const OverrideGlobalWrap = styled.div`
  display: flex;
  align-items: center;
  column-gap: 15px;
`;
export const OverrideGlobalLabel = styled.h3`
  display: flex;
`;
